module.exports = __webpack_public_path__ + "img/success-3.884e7542.svg";